import {
  DeviceEventEmitter,
  NativeAppEventEmitter,
  NativeEventEmitter,
  NativeModules,
  Platform,
} from 'react-native';

const { RTKRNBackgroundTimer } = NativeModules;
export const backgroundEmitter = new NativeEventEmitter(RTKRNBackgroundTimer);

class BackgroundTimer {
  uniqueId: number;

  callbacks: { [key: string]: any };

  backgroundTimer: number | NodeJS.Timeout | null;

  backgroundListener: any;

  constructor() {
    this.uniqueId = 0;
    this.callbacks = {};

    backgroundEmitter.addListener('backgroundTimer.timeout', (id) => {
      if (this.callbacks[id]) {
        const callbackById = this.callbacks[id];
        const { callback } = callbackById;
        if (!this.callbacks[id].interval) {
          delete this.callbacks[id];
        } else {
          Platform.OS === 'android'
            ? RTKRNBackgroundTimer.backgroundTimerSetTimeout(
                id,
                this.callbacks[id].timeout
              )
            : RTKRNBackgroundTimer.setTimeout(id, this.callbacks[id].timeout);
        }
        callback();
      }
    });
  }

  init() {
    return new BackgroundTimer();
  }

  // Original API
  start(delay = 0) {
    return Platform.OS === 'android'
      ? RTKRNBackgroundTimer.backgroundTimerStart(delay)
      : RTKRNBackgroundTimer.start(delay);
  }

  stop() {
    return Platform.OS === 'android'
      ? RTKRNBackgroundTimer.backgroundTimerStop()
      : RTKRNBackgroundTimer.stop();
  }

  runBackgroundTimer(callback, delay) {
    const EventEmitter = Platform.select({
      ios: () => NativeAppEventEmitter,
      android: () => DeviceEventEmitter,
    })();
    this.start(0);
    this.backgroundListener = EventEmitter.addListener(
      'backgroundTimer',
      () => {
        this.backgroundListener.remove();
        this.backgroundClockMethod(callback, delay);
      }
    );
  }

  backgroundClockMethod(callback, delay) {
    this.backgroundTimer = this.setTimeout(() => {
      callback();
      this.backgroundClockMethod(callback, delay);
    }, delay);
  }

  stopBackgroundTimer() {
    this.stop();
    this.clearTimeout(this.backgroundTimer);
  }

  // New API, allowing for multiple timers
  setTimeout(callback, timeout) {
    this.uniqueId += 1;
    const timeoutId = this.uniqueId;
    this.callbacks[timeoutId] = {
      callback,
      interval: false,
      timeout,
    };
    Platform.OS === 'android'
      ? RTKRNBackgroundTimer.backgroundTimerSetTimeout(timeoutId, timeout)
      : RTKRNBackgroundTimer.setTimeout(timeoutId, timeout);
    return timeoutId;
  }

  clearTimeout(timeoutId) {
    if (this.callbacks[timeoutId]) {
      delete this.callbacks[timeoutId];
      // RTKRNBackgroundTimer.clearTimeout(timeoutId);
    }
  }

  setInterval(callback, timeout) {
    this.uniqueId += 1;
    const intervalId = this.uniqueId;
    this.callbacks[intervalId] = {
      callback,
      interval: true,
      timeout,
    };
    Platform.OS === 'android'
      ? RTKRNBackgroundTimer.backgroundTimerSetTimeout(intervalId, timeout)
      : RTKRNBackgroundTimer.setTimeout(intervalId, timeout);
    return intervalId;
  }

  clearInterval(intervalId) {
    if (this.callbacks[intervalId]) {
      delete this.callbacks[intervalId];
      // RTKRNBackgroundTimer.clearTimeout(intervalId);
    }
  }
}

// TODO: Remove singleton pattern
export default new BackgroundTimer();
